import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { getPortalId } from 'MeetingsLib/selectors/authSelectors';
import { shouldLoadComplianceScript } from './utils/utils';
const COMPLIANCE_SCRIPT_URL = 'https://www.hubspot.com/wt-assets/static-files/compliance/index.js';
const COMPLIANCE_SCRIPT_ID = 'hubspot-compliance-script';

/**
 * Compliance component for HubSpot Cookie Banner
 *
 * This component is responsible for:
 * 1. Injecting the HubSpot compliance script (only for portal 53)
 * 2. Scanning cookies when the pathname changes (SPA behavior)
 * 3. Adding/updating the "Manage Cookies" link in the footer
 *
 * The compliance script only loads for portal 53 as per requirements.
 * For all other portals, this component does nothing.
 *
 * @see https://docs.google.com/document/d/1lyVQHtnVWiuCxdRz5BiA9MwpQOh9Kz22lYLKAznNn8c
 */
const Compliance = () => {
  const portalId = useSelector(getPortalId);
  const scriptInjectedRef = useRef(false);
  const shouldLoadScript = shouldLoadComplianceScript(portalId);
  useEffect(() => {
    if (!shouldLoadScript) {
      return;
    }

    // Compliance script handles the cookie banner so we can remove this from the disabledHsPopups override list
    // @ts-ignore mismatched types
    window.disabledHsPopups = window.disabledHsPopups.filter(disabledHsPopup => disabledHsPopup !== 'PRIVACY');

    // Inject the compliance script once
    if (!scriptInjectedRef.current) {
      const existingScript = document.getElementById(COMPLIANCE_SCRIPT_ID);
      if (!existingScript) {
        const script = document.createElement('script');
        script.id = COMPLIANCE_SCRIPT_ID;
        script.src = COMPLIANCE_SCRIPT_URL;
        script.type = 'text/javascript';
        script.defer = true;
        document.head.appendChild(script);
      }
      scriptInjectedRef.current = true;
    }
  }, [portalId, shouldLoadScript]);

  // This component doesn't render anything
  return null;
};
export default Compliance;